module.exports = __webpack_public_path__ + "img/02@2x.935f1ab6.png";